import { useEffect, useState } from "react";
import { apiRequest } from "@/lib/queryClient";

export type AdminRole = "admin" | "moderator";

type CheckState =
  | { status: "checking"; role: null }
  | { status: "ok"; role: AdminRole }
  | { status: "denied"; role: null };

/**
 * Calls /api/admin/check once and returns the current admin session role.
 * Used to gate pages and tailor the admin UI to the logged-in role.
 */
export function useAdminRole(): CheckState {
  const [state, setState] = useState<CheckState>({ status: "checking", role: null });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await apiRequest("GET", "/api/admin/check");
        const data = await res.json();
        if (!cancelled) {
          setState({ status: "ok", role: (data.role as AdminRole) || "admin" });
        }
      } catch {
        if (!cancelled) setState({ status: "denied", role: null });
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return state;
}
